export default __webpack_public_path__ + "static/media/adress.f0763ba9.svg";